import { DoceboCourseStatusSchema, type DoceboCourseStatus } from '~/types/academy/baseTraining';
import { AcademyTrainingsListingTab } from '~/types/academy/trainings-listing-tab';

const COMPLETED_STATUS: DoceboCourseStatus = 'completed';

/**
 * The Docebo statuses that a tab selects in the `status` filter. The list is static, so it is
 * correct before the API returns the filter options.
 */
export function getStatusFilterKeysForTab(tab: AcademyTrainingsListingTab): string[] {
    switch (tab) {
        case AcademyTrainingsListingTab.All:
            return [];

        case AcademyTrainingsListingTab.Open:
            return DoceboCourseStatusSchema.options.filter((status) => status !== COMPLETED_STATUS);

        case AcademyTrainingsListingTab.Completed:
            return [COMPLETED_STATUS];

        default:
            throw new Error(`Unknown tab: ${tab satisfies never}`);
    }
}
